import { render, staticRenderFns } from "./LayListNewspapers.vue?vue&type=template&id=39411484&scoped=true&"
import script from "./LayListNewspapers.vue?vue&type=script&lang=js&"
export * from "./LayListNewspapers.vue?vue&type=script&lang=js&"
import style0 from "./LayListNewspapers.vue?vue&type=style&index=0&id=39411484&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39411484",
  null
  
)

export default component.exports